






















































































import AccountMixin from './core'
import { cloneDeep } from '@rhitics/core/utils'
import { iam } from '@rhitics/core'

export default AccountMixin.extend({
  name: 'BasicPage'
})
